import { fetchUserDashboard, fetchUserDashboardWithParams, fetchUserDashboardByDate, UserDashboardParams } from '../../api/userdashboard/index';

export const fetchUserDashboardApi = async (params: UserDashboardParams) => {
  // Use the date-based API if DateTime is provided
  if (params.DateTime) {
    const response = await fetchUserDashboardByDate(params);
    return response;
  }
  // Otherwise use the default API
  const response = await fetchUserDashboard(params);
  return response;
};

export const fetchUserDashboardWithCustomParams = async (params: Record<string, any>) => {
  const response = await fetchUserDashboardWithParams(params);
  return response;
};